import { ChatStarterType } from '@mm/state/model/ChatStarterModel';
import { match } from 'path-to-regexp';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';

const buildResourceUrl = (
  chatbotId: number,
  entity: ChatStarterType,
): string => {
  const { id, kind, pageId } = entity;

  if (!id || !chatbotId) return '';

  const promoterParams = { chatbotId, promoterId: id, dialogueId: pageId };

  switch (kind) {
    case 'fb_comment_guard':
      return BotBuilderRoutes.commentGuardEdit.getLink(promoterParams);
    case 'customer_chat':
      return BotBuilderRoutes.customerChatEdit.getLink(promoterParams);
    case 'link':
      return BotBuilderRoutes.shareLinkEdit.getLink(promoterParams);
    case 'send_to_messenger':
      return BotBuilderRoutes.sendToMessengerEdit.getLink(promoterParams);
    case 'checkbox':
      return BotBuilderRoutes.checkboxPluginEdit.getLink(promoterParams);
    case 'optin':
      return BotBuilderRoutes.leadPopupsEdit.getLink(promoterParams);
    case 'landing_page':
      return BotBuilderRoutes.landingPagesEdit.getLink({
        chatbotId,
        landingPageId: id,
      });
    case 'welcome_page':
      return BotBuilderRoutes.facebookPageWelcomer.getLink({ chatbotId });
    case 'sms_keywords':
      return BotBuilderRoutes.smsKeywordEdit.getLink({
        chatbotId,
        smsKeywordId: id,
        dialogueId: pageId,
      });
    case 'instagram_welcomer':
      return BotBuilderRoutes.instagramWelcomerEdit.getLink(promoterParams);
    case 'instagram_story_mention':
      return BotBuilderRoutes.instagramStoryMentionEdit.getLink(promoterParams);
    case 'instagram_story_reaction':
      return BotBuilderRoutes.instagramStoryReactionEdit.getLink(
        promoterParams,
      );
    case 'instagram_comment_guard':
      return BotBuilderRoutes.instagramCommentGuardEdit.getLink(promoterParams);
    case 'instagram_live_comment_guard':
      return BotBuilderRoutes.instagramLiveEdit.getLink(promoterParams);
    default:
      return '';
  }
};

export const pathBuilder = {
  buildResourceUrl,
};
